<script>
import {Bar, Line} from 'vue-chartjs'
import API from '@/api/analytics'
import actions from '@/utils/defines/actions.js'

export default {
  extends: Bar,
  props: ['daterange', 'nfc_uids', 'groups', 'event_action'],
  mixins: [actions],
  data() {
    return {
      eventCountsForEvent: { },
    }
  },
  computed: {
    chartData: function() {
      return {
        labels: this.labels,
        datasets: [
          {
            type: 'line',
            label: this.$t('Analysis.max_temp'),
            borderColor: '#CC3300',
            backgroundColor: '#CC3300',
            borderWidth: 1,
            pointRadius: 3,
            pointHoverRadius: 5,
            showLine: true,
            fill: false,
            data: this.countsForEnv('max_temp'),
            yAxisID: 'line-temp'
          },
          {
            type: 'line',
            label: this.$t('Analysis.min_temp'),
            borderColor: '#f9d8cc',
            backgroundColor: '#f9d8cc',
            borderWidth: 1,
            pointRadius: 3,
            pointHoverRadius: 5,
            showLine: true,
            fill: false,
            data: this.countsForEnv('min_temp'),
            yAxisID: 'line-temp'
          },
          {
            type: 'line',
            label: this.$t('Analysis.ave_humidity'),
            borderColor: '#0033FF',
            backgroundColor: '#0033FF',
            borderWidth: 1,
            pointRadius: 3,
            pointHoverRadius: 5,
            showLine: true,
            fill: false,
            data: this.countsForEnv('average_humidity'),
            yAxisID: 'line-humidity'
          },
          {
            type: 'line',
            label: this.$t('Analysis.ave_pressure'),
            borderColor: '#999',
            backgroundColor: '#999',
            borderWidth: 1,
            pointRadius: 3,
            pointHoverRadius: 5,
            showLine: true,
            fill: false,
            data: this.countsForEnv('average_pressure'),
            yAxisID: 'line-pressure'
          },
          {
            label: this.$t(this.showActionName(this.event_action))+"("+this.$t('Analysis.User.male')+")",
            borderColor: '#009CE1',
            borderWidth: 1.5,
            backgroundColor: '#009CE1',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#009CE1',
            data: this.countsForGender('male'),
            yAxisID: 'bar-1'
          },
          {
            label: this.$t(this.showActionName(this.event_action))+"("+this.$t('Analysis.User.female')+")",
            borderColor: '#7FCDF0',
            borderWidth: 1.5,
            backgroundColor: '#7FCDF0',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#7FCDF0',
            data: this.countsForGender('female'),
            yAxisID: 'bar-1'
          },
          {
            label: this.$t(this.showActionName(this.event_action))+"("+this.$t('Analysis.User.other')+")",
            borderColor: '#BDEDFF',
            borderWidth: 1.5,
            backgroundColor: '#BDEDFF',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#BDEDFF',
            data: this.countsForGender('other'),
            yAxisID: 'bar-1'
          }
        ]
      }
    },
    labels: function() {
      return Object.keys(this.eventCountsForEvent).sort();
    }
  },
  mounted() {
    let obj = this;
    this.options = {
      legend: {
        position: "bottom"
      },
      onClick: function(evt, item){
        let el = this.getElementAtEvent(evt);
        if (el && el[0] && el[0]['_index'] ) {
          obj.$emit('changeGraph', obj.labels[el[0]['_index']]);
        }
      },
      tooltips: {
        mode: 'index',
        intersect: false
      },
      hover: {
        mode: 'index',
        intersect: true
      },
      scales: {
        xAxes: [{
          stacked: true,
          callback: {
            beforeUpdate: function(axis) {
              console.log(axis)
            }
          },
          gridLines: {
            display: false
          },
          ticks: {
            fontColor: "#999"
          }
        }],
        yAxes: [{
          id: 'line-temp',
          stacked: false,
          position: "right",
          ticks: {
            min: -10,
            max: 50,
            fontColor: "#999"
          },
          gridLines: {
            drawOnChartArea: false,
          },
          scaleLabel: {
            display: true,
            labelString: this.$t('Cuona.Device.temperature'),
            fontSize: 12,
            position: 'top'
          }
        },
        {
          id: 'line-humidity',
          stacked: false,
          position: "right",
          ticks: {
            min: 0,
            max: 100,
            fontColor: "#999"
          },
          gridLines: {
            drawOnChartArea: false,
          },
          scaleLabel: {
            display: true,
            labelString: this.$t('Cuona.Device.humidity'),
            fontSize: 12,
            position: 'top'
          }
        },
        {
          id: 'line-pressure',
          stacked: false,
          position: "right",
          ticks: {
            min: 900,
            max: 1100,
            fontColor: "#999"
          },
          gridLines: {
            drawOnChartArea: false,
          },
          scaleLabel: {
            display: true,
            labelString: this.$t('Cuona.Device.pressure'),
            fontSize: 12,
            position: 'top'
          }
        },
        {
          id: 'bar-1',
          stacked: true,
          ticks: {
            min: 0,
            fontColor: "#999"
          },
          scaleLabel: {
            display: true,
            labelString: this.$t('Analysis.Device.total_count'),
            fontSize: 12,
            position: 'top'
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      spanGaps: true,
      elements: {
        line: {
          tension: 0
        }
      },
      plugins: {
        datalabels: {
          display: false
        }
      }
    };
    this.updateData();
  },
  methods: {
    updateData() {
      const obj = this;
      const reqParams = {
        event: this.$route.params.id,
        nfc_uids: this.nfc_uids,
        daterange: this.daterange,
        groups: this.groups
      };
      API.getEventCountsForEvent(reqParams).then(function(response) {
        if (response && response.event_counts_for_event) {
          obj.eventCountsForEvent = response.event_counts_for_event;
        } else {
          obj.eventCountsForEvent = { };
        }
      });
    },
    countsForGender: function(element) {
      return this.labels.map(date => this.eventCountsForEvent[date][element] || 0);
    },
    countsForEnv(element) {
      return this.labels.map(date => Math.round((this.eventCountsForEvent[date] && this.eventCountsForEvent[date][element])*100)/100 || null);
    }
  },
  watch : {
    eventCountsForEvent: function() {
      this.renderChart(this.chartData, this.options)
    },
    daterange() {
      this.updateData();
    },
    nfc_uids() {
      this.updateData();
    },
    groups() {
      this.updateData();
    }
  }
}
</script>
